import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import heroImg from "../../../assets/images/young-student-working-assignment.webp";
import { Link } from "react-router-dom";

const ArdrendHero = () => {
  const { t } = useTranslation();
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div className="relative">
      <section className="relative h-screen min-h-[600px] flex items-center overflow-hidden bg-[#0b0f19]">

        {/* Dark gradient placeholder — visible instantly while image loads */}
        <div className="absolute inset-0 w-full h-full z-0 bg-gradient-to-br from-[#0b0f19] via-[#1a2333] to-[#05070c]" />

        {/* Hero image — fades in once loaded */}
        <div className={`absolute inset-0 w-full h-full z-[1] transition-opacity duration-700 ${imgLoaded ? "opacity-100" : "opacity-0"}`}>
          <img
            src={heroImg}
            alt=""
            role="presentation"
            className="w-full h-full object-cover object-center transition-transform duration-[6000ms] ease-out scale-105"
            fetchpriority="high"
            loading="eager"
            decoding="async"
            onLoad={() => setImgLoaded(true)}
          />
        </div>

        {/* Dark overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0f19]/95 via-[#0b0f19]/75 to-transparent w-full md:w-[70%] z-10"></div>
        
        <div className="relative z-20 w-full max-w-[1560px] mx-auto px-6 h-full flex flex-col justify-center">
          <div className="absolute top-1/2 -translate-y-1/2 left-6 opacity-100 pointer-events-auto">
            <div className="text-primary text-[12px] font-bold tracking-[0.25em] uppercase mb-5 mt-16 md:mt-24 transition-all duration-700 delay-100 opacity-100 translate-y-0">
              {t("home.hero.kicker")}
            </div>
            <h1 className="text-white text-4xl md:text-6xl lg:text-[72px] font-bold max-w-4xl leading-[1.05] tracking-tight mb-8 transition-all duration-700 delay-300 opacity-100 translate-y-0 drop-shadow-lg">
              {t("home.hero.titleLine1")}<br/>{t("home.hero.titleLine2")}
            </h1>
            <div className="flex flex-col sm:flex-row gap-3 transition-all duration-700 delay-500 opacity-100 translate-y-0">
              <Link className="bg-primary hover:bg-[#b0451e] text-white transition-colors rounded-full pl-5 pr-2 py-2 inline-flex items-center gap-3 group self-start shadow-md w-full sm:w-auto justify-between sm:justify-start" to="/courses">
                <span className="text-[11px] font-bold uppercase tracking-wider">{t("home.hero.exploreCourses")}</span>
                <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-primary transition-colors shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </div>
              </Link>
              <a href="https://app.e1xacademy.net/pioneer-cohort" className="bg-transparent hover:bg-white/10 text-white rounded-full px-5 py-3 inline-flex items-center justify-center text-[11px] font-bold border border-white/30 transition-colors cursor-pointer uppercase tracking-wider w-full sm:w-auto">
                {t("home.hero.claimScholarship")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArdrendHero;
